// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"81bddc38","453":"ef15f7cf"}[chunkId] + ".chunk.js";
};